import React from "react";

const Java_Short = () => {
  return (
    <div>
      <h1>Java Short</h1>
      <p>This page provides explanations, examples, and common use-cases for Java Short in Java.</p>
    </div>
  );
};

export default Java_Short;
